import MyContext from "@/shared/contexts/AppContext";
import { CarregarPermissoes, ValidarPermissao } from "./auth.service";
import { PermissionEnum } from "@/modules/system/auth/domain/enums/permission.enum";
import { RoleEnum } from "@/modules/system/auth/domain/enums/role.enum";
import { useContext } from "react";

/**
 * Valida se o usuário tem a permissão necessária.
 * @param permissao Permissão requisitada.
 * @param nivel Nível necessário
 * @returns True or False.
 */
export function ValidarPermissaoUsuario(permissao: RoleEnum, nivel: PermissionEnum) {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  return context.state.username
    ? ValidarPermissao(CarregarPermissoes(), [{ role: permissao, level: nivel }])
    : false
}